var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09014 11.0326L9.00014 8.12258L11.9101 11.0326C12.2026 11.3251 12.6751 11.3251 12.9676 11.0326C13.2601 10.7401 13.2601 10.2676 12.9676 9.97508L9.52514 6.53258C9.23264 6.24008 8.76014 6.24008 8.46764 6.53258L5.02514 9.97508C4.73264 10.2676 4.73264 10.7401 5.02514 11.0326C5.31764 11.3176 5.79764 11.3251 6.09014 11.0326Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.fe3451c0e2e2c487b97eefecad232301.svg";
export { ForwardRef as ReactComponent };